import { render, staticRenderFns } from "./Loisirs.vue?vue&type=template&id=1dae29b4&"
import script from "./Loisirs.vue?vue&type=script&lang=js&"
export * from "./Loisirs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports